export default __webpack_public_path__ + "locales/fr/FillPDFDialog.json?hash=ac526aacc32831c246c77ad6a9b36721";